import { Typography, useTheme } from '@mui/material';
import { Modal } from 'sharedComponents/Modal';
import { PrimaryButton } from 'sharedComponents/Buttons';
import { Box, styled } from '@mui/material';
import { ApplyLinkStringType, classifyStringType } from 'utils/text';
import { ATSJobViewDataTestIds } from 'data-testids/ATS';

interface JobViewApplyModalProps {
  open: boolean;
  onClose: () => void;
  text: string;
}

interface ModalBodyTextProps {
  text: string;
  stringType: ApplyLinkStringType;
}

export const JobViewApplyModal: React.FC<JobViewApplyModalProps> = ({ open, onClose, text }) => {
  const stringType = classifyStringType(text);
  const theme = useTheme();
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Apply To Job"
      ctaButtons={
        <CTA>
          <PrimaryButton size="extraLarge" onClick={onClose}>
            Okay
          </PrimaryButton>
        </CTA>
      }
      borderRadius={theme.shape.borderRadius}
    >
      <div data-testid={ATSJobViewDataTestIds.APPLY_MODAL}>
        <ModalBodyText text={text} stringType={stringType} />
      </div>
    </Modal>
  );
};

const ModalBodyText: React.FC<ModalBodyTextProps> = ({ text, stringType }) => {
  if (stringType === ApplyLinkStringType.EMAIL) {
    return <Typography>Please submit your application to {text}</Typography>;
  } else if (stringType === ApplyLinkStringType.OTHER) {
    return <Typography>{text}</Typography>;
  }
  return null;
};

export const CTA = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'end',
  marginTop: theme.spacing(3),
}));
